module.exports = __webpack_public_path__ + "img/tag_FX_KRW.e554718e.png";